<template>
  <v-card>
    <v-card-title>
      <span class="headline">例外納入指示</span>
    </v-card-title>
    <v-card-actions>
      <v-btn
        :disabled="selected.length === 0 || !canApply"
        @click="exceptionApply()"
        v-if="!isAcceptor"
        class="btn-search"
        >例外指示申請</v-btn
      >
      <v-btn
        :disabled="!canCancel || selected.length === 0"
        @click="exceptionApplyCancel()"
        v-if="!isAcceptor"
        class="btn-search"
        >例外指示取消</v-btn
      >

      <v-btn @click="$router.go(-1)">{{ $t('app.buttons.back') }}</v-btn>
    </v-card-actions>
    <v-data-table
      :headers="headers"
      :items="shipments"
      :rows-per-page-items="[-1]"
      item-key="shipmentId"
      select-all
      v-model="selected"
    >
      <template slot="headerCell" slot-scope="props">
        <span>
          {{ props.header.text }}
        </span>
      </template>
      <template slot="items" slot-scope="props">
        <td>
          <v-checkbox
            hide-details
            primary
            v-model="props.selected"
          ></v-checkbox>
        </td>
        <td>
          {{ props.item.displayStatus }}
        </td>
        <td>{{ props.item.containerNo }}</td>
        <td>{{ props.item.skuCode }}</td>
        <td>{{ props.item.productCode + ':' + props.item.productName }}</td>
        <td>
          <remote-autocomplete
            @change="
              propsChanged(
                'finallyWarehouseId',
                props.item.finallyWarehouseId,
                props.item
              )
            "
            v-if="!isAcceptor"
            :disabled="isAcceptor"
            :rules="[(v) => !!v || `希望納入場所 can not be null`]"
            label="希望納入場所"
            url="warehouses/reservable-kv"
            v-model="props.item.finallyWarehouseId"
          ></remote-autocomplete>
          <remote-autocomplete
            v-if="isAcceptor"
            :disabled="isAcceptor"
            :rules="[(v) => !!v || `希望納入場所 can not be null`]"
            label="希望納入場所"
            url="warehouses/kv"
            v-model="props.item.finallyWarehouseId"
          ></remote-autocomplete>
        </td>
        <td>
          <date-picker
            :key="props.item.id"
            :change="
              propsChanged(
                'forecastDeliveryDate',
                props.item.forecastDeliveryDate
              )
            "
            :disabled="!props.item.finallyWarehouseId"
            :rules="[(v) => !!v || `希望納入予定日 can not be null`]"
            label="希望納入予定日"
            :min="today"
            :allowed-dates="
              (val) => props.item.availableDays.indexOf(val) === -1
            "
            v-model="props.item.forecastDeliveryDate"
          ></date-picker>
        </td>
        <td>
          <v-text-field
            @change="
              propsChanged(
                'forecastDeliveryTime',
                props.item.forecastDeliveryTime
              )
            "
            :rules="[
              (v) =>
                /^(((0|1)\d)|(2[0-3]))[0-5][0-9]$/.test(v) ||
                `4桁の数の有効時間を入力してください`,
            ]"
            label="希望納入時間"
            v-model="props.item.forecastDeliveryTime"
          />
        </td>
        <td>
          <v-text-field
            @change="propsChanged('remark', props.item.remark)"
            clearable
            :rules="[(v) => !!v || `コメント can not be null`]"
            label="コメント"
            v-model="props.item.remark"
          ></v-text-field>
        </td>
        <td>
          <v-btn
            @click="exceptionApplyConfirm(props.item)"
            v-if="isAcceptor"
            class="btn-search"
            >承認</v-btn
          >
          <v-btn
            @click="exceptionApplyReject(props.item)"
            v-if="isAcceptor"
            class="btn-search"
            >拒否</v-btn
          >
        </td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      valid: false,
      query: {},
      user: {},
      id: null,
      shipments: [],
      selected: [],
      shipment: {},
      today: null,
      availableDays: [],
      headers: [
        {
          text: '申請ステータス',
          value: '',
          sortable: false,
        },
        {
          text: 'コンテナ番号',
          value: '',
          sortable: false,
        },
        {
          text: '品種名',
          value: '',
          sortable: false,
        },
        {
          text: '代表品番',
          value: '',
          sortable: false,
        },
        {
          text: '希望納入場所',
          value: '',
          sortable: false,
        },
        {
          text: '希望納入予定日',
          value: '',
          sortable: false,
        },
        {
          text: '希望納入時間',
          value: '',
          sortable: false,
        },
        {
          text: 'コメント',
          value: '',
          sortable: false,
        },
        {
          text: 'actions',
          value: '',
          sortable: false,
        },
      ],

      errors: {
        NO_CONFIG: '当該納入場所を指定できません。',
        NO_WAREHOUSE_MANAGER: this.$t('B0800.messages.noWhsManager'),
        DIFFERENT_BU:
          '事業本部が一致していないので、当該データを操作できません。',
        DIFFERENT_BUSINESS_UNIT:
          '操作者が属するBU以外のデータを操作するのは許可されません。',
        NOT_APPLY_STATUS:
          '例外納入指示申請以外のデータに対して承認/拒否を操作できません。',
      },
    }
  },
  methods: {
    validInOneYear() {
      for (var i = 0; i < this.shipments.length; i++) {
        var eta = this.shipments[i].eta
        var forecastDeliveryDate = this.shipments[i].forecastDeliveryDate
        if (this.$daysBetween(eta, forecastDeliveryDate) > 30) {
          return false
        }
      }
      return true
    },
    param(shipment) {
      return {
        reserveDate: shipment.forecastDeliveryDate,
        reserveTime: this.formatedTime(shipment.forecastDeliveryTime),
        remark: shipment.remark,
        warehouseId: shipment.finallyWarehouseId,
      }
    },
    formatedTime(forecastDeliveryTime) {
      if (forecastDeliveryTime) {
        var time = this.$insert(forecastDeliveryTime, 0, 2, ':')
        time = this.$insert(time, 0, 5, ':')
        time = time + '00'
        return time
      }
      return null
    },
    getEmployee() {
      this.$http.get(`/employees/current`).then((res) => {
        this.user = res.data
      })
    },
    getUsableDays(shipment) {
      if (this.isAcceptor) {
        shipment.availableDays = []
        return
      }
      if (shipment && shipment.finallyWarehouseId) {
        this.$http
          .get(
            `/warehouse-container-settings/shipment/${shipment.shipmentId ||
              shipment.id}/warehouse/${
              shipment.finallyWarehouseId
            }/available-days`
          )
          .then((res) => {
            shipment.availableDays = res.data
          })
      }
    },
    load() {
      this.shipments = []
      this.selected = []
      var idArray = this.$route.query.ids.split(',')
      Promise.all(
        idArray.map((id) => {
          this.$http.get(`/reserved-shipment/${id}`).then((res) => {
            var shipment = res.data
            var forecastDeliveryTime = shipment.forecastDeliveryTime

            shipment.forecastDeliveryTime =
              forecastDeliveryTime &&
              [
                forecastDeliveryTime.slice(0, 2),
                forecastDeliveryTime.slice(3, 5),
              ].join('')
            this.shipments.push(shipment)
            this.getUsableDays(shipment)
          })
        })
      ).then(() => {
        this.shipments = this.shipments.sort((a, b) =>
          a.containerNo.localeCompare(b.containerNo)
        )
        this.getEmployee()
      })
    },
    send(id) {
      return this.$http
        .put(`/delivery-orders/${id}/send-email-date`)
        .then(() => {
          this.$message('', '納入指示済')
        })
        .catch((err) => {
          this.$showError(err)
        })
    },
    dealInstructionSend(data, i, failedList) {
      this.$http
        .put(
          `warehouse-container-settings/exception-apply/${data[i].shipmentId}`,
          this.param(data[i])
        )
        .then((res) => {
          if (!res.data.success) {
            failedList.push({
              ...data[i],
              errors: res.data.localeMessage,
            })
          }
          this.doInstructionSend(i, data, failedList)
        })
        .catch((res) => {
          var existErrorMsg = this.errors[res.response.data.message]
          if (existErrorMsg) {
            failedList.push({
              ...data[i],
              errors: existErrorMsg,
            })
          } else {
            failedList.push({
              ...data[i],
              errors: 'Error',
            })
          }
          this.doInstructionSend(i, data, failedList)
        })
    },

    doInstructionSend(i, data, failedList) {
      if (i < data.length - 1) {
        this.dealInstructionSend(data, i + 1, failedList)
      } else {
        if (failedList.length === 0) {
          this.selected = []
          this.load()
          this.showMsg(failedList)
        }
        if (failedList.length > 0) {
          this.selected = []
          this.load()
          this.showMsg(failedList)
        }
      }
    },
    exceptionApply() {
      var successList = []
      var failedList = []
      var i = 0
      if (!this.validInOneYear()) {
        this.$confirm({
          content:
            'ＥＴＡから３０日以上経過していますので、問題がないかご確認ください',
          action: 'そのまま保存',
          rejectAction: 'キャンセル',
        })
          .then(() => {
            this.dealInstructionSend(this.selected, i, failedList)
          })
          .catch(() => {})
      } else {
        this.dealInstructionSend(this.selected, i, failedList)
      }
    },
    showMsg(failedList) {
      if (failedList.length > 0) {
        var errors = failedList.map((f) => {
          return {
            blNo: f.containerNo,
            errors: f.errors,
          }
        })
        this.$fullMessage('エラー', errors)
      } else {
        this.$message('', '例外納入指示申請されました。')
      }
    },
    exceptionApplyCancel() {
      Promise.all(
        this.selected.map((s) => {
          this.$http
            .put(
              `warehouse-container-settings/exception-apply/${
                s.shipmentId
              }/cancel`,
              this.param(s)
            )
            .then((res) => {
              if (res.data.success) {
                this.load()
                this.$message('', '例外納入指示申請が取消されました。')
              } else {
                this.$message('', res.data.localeMessage)
              }
            })
            .catch((err) => {
              this.$showError(err)
            })
        })
      )
    },
    exceptionApplyConfirm(shipment) {
      var id = shipment.shipmentId
      this.$http
        .put(
          `warehouse-container-settings/exception-apply/${id}/confirm`,
          this.param(shipment)
        )
        .then(() => {
          this.send(id).then(() => {
            this.load()
          })
        })
        .catch((err) => {
          this.$showError(err)
        })
    },
    exceptionApplyReject(shipment) {
      this.$http
        .put(
          `warehouse-container-settings/exception-apply/${
            shipment.shipmentId
          }/reject`,
          this.param(shipment)
        )
        .then((res) => {
          if (res.data.success) {
            this.load()
            this.$message('', '例外納入指示申請が拒否されました。')
          } else {
            this.$message('', res.data.localeMessage)
          }
        })
        .catch((err) => {
          this.$showError(err)
        })
    },
    propsChanged(props, data, shipment) {
      if (shipment) {
        this.getUsableDays(shipment)
      }
      this.shipments
        .filter((s) => !s[props])
        .forEach((s) => {
          this.$set(s, props, data)
          if ('finallyWarehouseId' === props) {
            this.getUsableDays(s)
          }
          // s[props] = data
        })
    },
  },
  computed: {
    isAdmin() {
      return this.$isAdmin()
    },
    isAcceptor() {
      var acceptor = 'ROLE_SJL_ACCEPTOR'
      var importSales = 'ROLE_SJL_IMPORT_SALES'
      var importPromote = 'ROLE_SJL_IMPORT_PROMOTE'
      return (
        this.user &&
        this.user.roles &&
        (this.user.roles.includes(acceptor) ||
          this.user.roles.includes(importSales) ||
          this.user.roles.includes(importPromote))
      )
    },
    isSjl() {
      return this.user.companyName === 'SJL'
    },
    canApply() {
      return (
        this.selected.filter((s) => s.displayStatus === '例外納入指示申請')
          .length === 0 &&
        this.selected.filter((s) => s.displayStatus === '事前例外納入指示申請')
          .length === 0 &&
        this.selected.filter((s) => !s.finallyWarehouseId).length === 0 &&
        this.selected.filter((s) => !s.forecastDeliveryDate).length === 0 &&
        this.selected.filter((s) => !s.forecastDeliveryTime).length === 0 &&
        this.selected.filter((s) => !s.remark).length === 0
      )
    },
    canCancel() {
      return (
        this.selected.filter(
          (s) =>
            s.displayStatus !== '例外納入指示申請' &&
            s.displayStatus != '事前例外納入指示申請'
        ).length === 0
      )
    },
  },
  watch: {},
  mounted() {
    this.today = this.$route.query.today
    this.load()
  },
}
</script>

<style></style>
